'use client';
import { TPartner } from '@/domain/Partner.domain';
import { customGA4Id, GoogleTMConfiguration } from '@/service/utils/gtm';
import Script from 'next/script';

const checkAndUpdateCookie = () => {
    if (!document.cookie) {
        setTimeout(() => {
            if (!document?.cookie) {
                // eslint-disable-next-line no-var
                var wr_ga_data = `_gid=GA1.2.${window?.ga
                    ?.getAll?.()?.[0]
                    ?.get?.('_gid')}; _ga=GA1.1.${window?.ga?.getAll?.()?.[0]?.get?.('clientId')};`;

                Object.defineProperty(document, 'cookie', {
                    get: function () {
                        return wr_ga_data;
                    },
                    set: function (value) {
                        wr_ga_data = value;
                    },
                });
            }
        }, 10000);
    }
};

export const GTMInit = ({ partner }: { partner: TPartner }) => {
    return (
        <>
            <Script
                id="GTMinject"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: GoogleTMConfiguration,
                }}
                onReady={checkAndUpdateCookie}
            />
            {!!partner.ga4_id && (
                <Script
                    id="CustomGA4inject"
                    strategy="lazyOnload"
                    dangerouslySetInnerHTML={{
                        __html: customGA4Id(partner.ga4_id),
                    }}
                />
            )}
        </>
    );
};
